import { querySystemCity } from '@api/roleManagement';
import {
  SystemCityItemInterface,
  SystemCityMapItemInterface,
  systemCityAtom,
  systemCityMapAtom
} from '@store/systemCityStore';
import { recursiveIterateKeys } from '@utils/tool';
import { useEffect, useMemo } from 'react';
import { useRecoilState } from 'recoil';

interface ResultInterface {
  data: SystemCityItemInterface[];
  map: SystemCityMapItemInterface;
  provinceData: SystemCityItemInterface[];
}

export function UseSystemCity(isReload: boolean = false) {
  const [systemCity, setSystemCity] = useRecoilState<any>(systemCityAtom);
  const [systemCityMap, setSystemCityMap] =
    useRecoilState<SystemCityMapItemInterface>(systemCityMapAtom);

  const provinceRegionData = useMemo(() => {
    if (systemCity?.length > 0) {
      return systemCity.map((province: SystemCityItemInterface) => ({
        ...province,
        children: []
      }));
    }
    return [];
  }, [systemCity]);

  const getList = async () => {
    const res: any = await querySystemCity();
    //重组省市格式数据
    const updatedCity = recursiveIterateKeys(res?.list || []);
    setSystemCity(updatedCity);

    const newMap = updatedCity.reduce(
      (total: SystemCityMapItemInterface, cur: SystemCityItemInterface) => {
        const { areaCode } = cur;
        total[areaCode] = cur;
        return total;
      },
      {}
    );
    setSystemCityMap(newMap);
  };

  const getStoreList = () => {
    if (systemCity && systemCity.length > 0 && !isReload) {
      return;
    }
    getList();
  };

  useEffect(() => {
    getStoreList();
  }, []);

  const result: ResultInterface = {
    data: systemCity,
    map: systemCityMap,
    provinceData: provinceRegionData
  };

  return result;
}
